import React, { useState } from "react";
import Helmet from "react-helmet";
import PropTypes from "prop-types";
import { useInterval } from "../../utils/hooks";

// export const isYotpoReady = () => {
//   /* global yotpo */
//   if (window.Yotpo && window.yotpo) {
//     // Undocumented call in Yotpo SDK to check if Yotpo is ready
//     return yotpo.getState() === 'ready'
//   }

//   return false
// }

const YotpoSdk = () => {
  const [isRefreshDone, setIsRefreshDone] = useState(false);

  // Ensure widgets load after navigating away and then back
  // https://support.yotpo.com/en/article/loading-yotpo-with-ajax
  useInterval(
    () => {
      if (!isRefreshDone && window.Yotpo && window.yotpo) {
        const api = new window.Yotpo.API(window.yotpo);

        // Hack - give the Yotpo refresh time to finish. Otherwise, it might not
        // be done in time and the widgets will be blank.
        setTimeout(() => {
          api.refreshWidgets();
        }, 2000);
        setIsRefreshDone(true);
      }
    },
    !isRefreshDone ? 500 : null
  );

  return (
    <Helmet
      script={[
        {
          type: "text/javascript",
          innerHTML: `
          (function e() {
            var e = document.createElement("script");
            e.type = "text/javascript", e.async = true, e.src = "//staticw2.yotpo.com/${process.env.REACT_APP_YOTPO_API_KEY}/widget.js";
            var t = document.getElementsByTagName("script")[0]; t.parentNode.insertBefore(e, t) })();
          `,
        },
      ]}
    />
  );
};

export default YotpoSdk;

export const YotpoSdkWrapper = ({ children }) => (
  <>
    <YotpoSdk />
    {children}
  </>
);

YotpoSdkWrapper.propTypes = {
  children: PropTypes.any.isRequired,
};
